import { makeStyles } from "components/providers/makeStyles";

export const useRankingsAndMembershipsPageStyles = makeStyles((theme) => ({
    page: {
        "&&": {
            paddingBottom: theme.spacing(8)
        },
    },
    seriesList: {
        padding: 0
    }
}));
